<router-outlet></router-outlet>
<div style="display: none;">
  <a href="javascript:void()" routerLink="/turnos">TURNOS </a>
  <a href="javascript:void()" routerLink="/simulador">SIMULADOR </a>
  <a href="javascript:void()" routerLink="/politicas">POLITICAS </a>
</div>
